import React from 'react';
import PropTypes from 'prop-types';
import FormModal from "../../../components/common/modals/FormModal";
import {useFragment, useMutation} from "react-relay";
import {allCmsSpecialtiesDropdown} from "../../../relay/Fragments";
import {createOptions} from "../../../helpers/utils";
import graphql from "babel-plugin-relay/macro";
import * as yup from "yup";
import dayjs from "dayjs";
import {useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import {toast} from "react-toastify";
import HorizontalFormSelect from "../../../components/common/horizontal-form-inputs/HorizontalFormSelect";
import HorizontalFormInput from "../../../components/common/horizontal-form-inputs/HorizontalFormInput";
import HorizontalFormDate from "../../../components/common/horizontal-form-inputs/HorizontalFormDate";
import {bandedSchema} from "../../../helpers/bandedUtils";
import {integerInputSchema} from "../../../helpers/utils";

const EditFacilityLocationCmsSpecialtyModal = ({showModal, onClose, selectedCmsSpecialty, cmsSpecialties}) => {
    const mutation = graphql`
        mutation EditFacilityLocationCmsSpecialtyModalMutation($id: ID!, $cmsSpecialtyId: ID!, $numberOfBeds: DecimalInput, $effectiveFrom: DateOnly!, $effectiveTo: DateOnly!) {
            facilityLocation {
                modifyCmsSpecialty(input: {facilityLocationCmsSpecialtyId: $id, cmsSpecialtyId: $cmsSpecialtyId, numberOfBeds: $numberOfBeds, effectiveFrom: $effectiveFrom, effectiveTo: $effectiveTo}) {
                    facilityLocationCmsSpecialty {
                        id
                        facilityLocation {
                            cmsSpecialties {
                                ...FacilityLocationCmsSpecialties_CmsSpecialties
                            }}}}}}`
    const cmsSpecialtiesData = useFragment(allCmsSpecialtiesDropdown, cmsSpecialties).filter(x => x.applicableVersion.appliesToFacilities);
    const cmsSpecialtyOptions = createOptions(
        cmsSpecialtiesData, 
        'id', 
        'applicableVersion.name'
    );
    const [commitMutation, isInFlight] = useMutation(mutation);
    const effectiveFrom = selectedCmsSpecialty?.effectiveFrom ? dayjs(selectedCmsSpecialty?.effectiveFrom).toDate() : '';
    const effectiveTo = selectedCmsSpecialty?.effectiveTo ? dayjs(selectedCmsSpecialty?.effectiveTo).toDate() : '';
    const defaultValues = {
        id: selectedCmsSpecialty?.id,
        cmsSpecialtyId: selectedCmsSpecialty?.cmsSpecialty.id,
        effectiveFrom: effectiveFrom,
        effectiveTo: effectiveTo,
        numberOfBeds: selectedCmsSpecialty?.numberOfBeds
    };
    const schema = bandedSchema.shape({
        cmsSpecialtyId: yup.string().required("CMS Specialty is required"),
        numberOfBeds: integerInputSchema
            .when('cmsSpecialtyId', {
                is: (val) => cmsSpecialtiesData.some(x => x.id === val && x.applicableVersion.requiresBedCount),
                then: (schema) => schema.test('is-required', 'Number of beds is required for this specialty', (x) => x !== '' && x !== undefined),
                otherwise: (schema) => schema,
            })
    });

    const methods = useForm({values: defaultValues, resolver: yupResolver(schema)});

    const handleSubmit = (data) => {
        commitMutation({variables: {...data},
            onCompleted: (data) => {
                if(data.facilityLocation) {
                    toast.success("CMS Specialty has been updated")
                    onClose();
                }
            }})
    }
    return (
        <FormModal showModal={showModal}
                   onClose={onClose}
                   title={"Update CMS Specialty"}
                   methods={methods}
                   isInFlight={isInFlight}
                   onSubmit={handleSubmit}
        >
            <HorizontalFormSelect options={cmsSpecialtyOptions} controlId={"cmsSpecialtyId"} label={"CMS Specialty"} readMode={true} />
            <HorizontalFormInput controlId={"numberOfBeds"} label={"Number of Beds"} type={"number"} />
            <HorizontalFormDate controlId={"effectiveFrom"} label={"Effective From"} />
            <HorizontalFormDate controlId={"effectiveTo"} label={"Effective To"} />
        </FormModal>
    )
}
EditFacilityLocationCmsSpecialtyModal.propTypes = {
    showModal: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    selectedCmsSpecialty: PropTypes.object.isRequired,
    cmsSpecialties: PropTypes.array.isRequired,
}
export default EditFacilityLocationCmsSpecialtyModal